/**
 * Top Bar 1
 */
(() => {
  const quickOrderWrapper = document.querySelector('.topbar .quick-order-wrapper');
  const quickOrder = document.querySelector('header .header-full .quickordertoggle');
  if (quickOrderWrapper && quickOrder) {
    quickOrderWrapper.append(quickOrder);
  }

  const quickListWrapper = document.querySelector('.topbar .quick-list-wrapper');
  const quickList = document.querySelector('header .header-full .vuequicklistdropdown_elem');
  if (quickListWrapper && quickList) {
    quickListWrapper.replaceWith(quickList);
  }
})();
